import { page } from './page';
import { refresh } from './refresh';

const en = {
    metaTitle: 'APC Plus — Digital vouchers, one account',
    metaDescription:
        'Deposit, manage your credits, and explore digital vouchers in one APC Plus account. AI agent access is in design.',
    language: 'Language',
    navHow: 'How it works',
    navAgents: 'AI Agents',
    signIn: 'Sign in',
    brandHome: 'APC Plus, back to top',
    eyebrow: 'Meet APC Plus',
    titleLead: 'Digital value, ',
    titleAccent: 'ready to use.',
    heroCopy:
        'Deposit, manage your credits, and explore digital vouchers in one APC Plus account. We’re also designing AI agent access to help you find what you need while you stay in control.',
    createAccount: 'Create an account',
    exploreAgents: 'Explore AI Agents',
    heroNote: 'Already have an account?',
    heroNoteLink: 'Sign in to APC Plus',
    previewLabel: 'Illustration of the APC Plus experience',
    previewSub: 'Experience overview',
    yourAccount: 'Your account',
    credits: 'Available credits',
    balanceHint: 'Your balance appears in your account',
    giftCards: 'Explore gift cards',
    categories: 'Categories',
    shopping: 'Shopping',
    gaming: 'Gaming',
    food: 'Food',
    previewFoot: 'Deposits and voucher listings, together in your account.',
    illustration: 'Illustration',
    howKicker: 'How it works',
    howTitle: 'One place to get started and explore.',
    howLead: 'APC Plus brings your account, deposit area, and voucher listings together.',
    step1Title: 'Create an account',
    step1Text: 'Register or sign in to open your APC Plus account.',
    step2Title: 'Follow deposit steps',
    step2Text: 'Open the deposit area and use the token and network instructions shown in your account.',
    step3Title: 'Browse vouchers',
    step3Text: 'Explore the available listings and check which products fit your region and needs.',
    agentsKicker: 'On the roadmap · AI Agents',
    agentsTitle: 'Your assistant can help. You decide.',
    agentsLead:
        'The next APC Plus experience is being designed to let a connected AI assistant search vouchers, check your credits, and prepare a checkout using your existing account.',
    agentPoint1: 'Ask an assistant to find eligible vouchers and compare the details.',
    agentPoint2: 'Review the exact purchase in APC Plus before it goes through.',
    agentPoint3: 'Control what an agent can see, and disconnect it when you choose.',
    agentsDisclaimer:
        'AI agent connections are a design preview. They are not available in the live APC Plus app yet. Optional purchases within a set budget are planned for a later phase.',
    demoLabel: 'Illustrative AI agent purchase flow',
    demoTitle: 'Shop with an assistant',
    demoSub: 'Proposed APC Plus flow',
    concept: 'Concept',
    youAsk: 'You ask',
    prompt: '“Find a gift card I can use in my region.”',
    flow1: 'Assistant finds eligible options',
    flow2: 'APC Plus prepares the price and details',
    flow3: 'You approve the purchase in APC Plus',
    demoFoot: 'Your approval would happen in APC Plus, not in an assistant chat.',
    startKicker: 'Get started',
    startTitle: 'Your APC Plus account starts here.',
    startLead:
        'Sign in to use the deposit and voucher listing features already available in APC Plus. If you’re new, create an account first.',
    startPoint1: 'Access your deposit instructions.',
    startPoint2: 'Browse the current voucher listings.',
    startPoint3: 'AI agent access is being designed for this same account.',
    continueTitle: 'Continue to APC Plus',
    continueText: 'Choose the path that fits you. Both links open the existing APC Plus app.',
    accessNote: 'AI agent access will be added separately when it launches.',
    footerBlurb:
        'Digital vouchers and a clearer way to use your APC Plus balance. AI agent access is in design.',
    official: 'Official website',
    backTop: 'Back to top ↑',
    trademark: 'APC Plus is a trademark of APC TECHNOLOGY SDB BHD.',
    rights: 'All rights reserved.',
    footerNav: 'Footer navigation',
};

const zh = {
    metaTitle: 'APC Plus — 数字礼品卡，一个账户',
    metaDescription: '在一个 APC Plus 账户中充值、管理积分并浏览数字礼品卡。AI 助手接入正在设计中。',
    language: '语言',
    navHow: '使用方式',
    navAgents: 'AI 助手',
    signIn: '登录',
    brandHome: 'APC Plus，回到顶部',
    eyebrow: '认识 APC Plus',
    titleLead: '数字价值，',
    titleAccent: '随时可用。',
    heroCopy:
        '在一个 APC Plus 账户中充值、管理积分，并浏览数字礼品卡。我们正在设计 AI 助手接入，帮你找到所需内容，同时由你掌控。',
    createAccount: '创建账户',
    exploreAgents: '探索 AI 助手',
    heroNote: '已有账户？',
    heroNoteLink: '登录 APC Plus',
    previewLabel: 'APC Plus 体验示意图',
    previewSub: '体验概览',
    yourAccount: '你的账户',
    credits: '可用积分',
    balanceHint: '余额会显示在你的账户中',
    giftCards: '探索礼品卡',
    categories: '分类',
    shopping: '购物',
    gaming: '游戏',
    food: '美食',
    previewFoot: '充值与礼品卡列表，都在你的账户里。',
    illustration: '示意图',
    howKicker: '使用方式',
    howTitle: '一个地方，开始并探索。',
    howLead: 'APC Plus 将账户、充值区和礼品卡列表放在一起。',
    step1Title: '创建账户',
    step1Text: '注册或登录，开通你的 APC Plus 账户。',
    step2Title: '按充值步骤操作',
    step2Text: '打开充值区，并按照账户中显示的代币和网络说明操作。',
    step3Title: '浏览礼品卡',
    step3Text: '查看现有列表，确认哪些商品适合你的地区和需求。',
    agentsKicker: '路线图 · AI 助手',
    agentsTitle: '助手可以帮忙。决定权在你。',
    agentsLead:
        '下一代 APC Plus 体验正在设计中，让已连接的 AI 助手搜索礼品卡、查看积分，并用你现有的账户准备结账。',
    agentPoint1: '让助手查找符合条件的礼品卡并比较详情。',
    agentPoint2: '在 APC Plus 中核对具体购买内容，然后再完成。',
    agentPoint3: '控制助手可以看到什么，并随时断开连接。',
    agentsDisclaimer:
        'AI 助手连接目前只是设计预览，尚未在正式的 APC Plus 应用中提供。在设定预算内的可选购买将在后续阶段推出。',
    demoLabel: 'AI 助手购买流程示意图',
    demoTitle: '和助手一起选购',
    demoSub: '拟议的 APC Plus 流程',
    concept: '概念',
    youAsk: '你说',
    prompt: '“帮我找一张可以在我所在地区使用的礼品卡。”',
    flow1: '助手找出符合条件的选项',
    flow2: 'APC Plus 准备价格和详情',
    flow3: '你在 APC Plus 中确认购买',
    demoFoot: '确认会在 APC Plus 中完成，而不是在助手对话里。',
    startKicker: '开始使用',
    startTitle: '你的 APC Plus 账户从这里开始。',
    startLead: '登录即可使用 APC Plus 中已提供的充值和礼品卡列表功能。如果是新用户，请先创建账户。',
    startPoint1: '查看充值说明。',
    startPoint2: '浏览当前的礼品卡列表。',
    startPoint3: 'AI 助手接入正在为同一个账户进行设计。',
    continueTitle: '继续前往 APC Plus',
    continueText: '选择适合你的方式。两个链接都会打开现有的 APC Plus 应用。',
    accessNote: 'AI 助手接入将在上线时另行添加。',
    footerBlurb: '数字礼品卡，以及更清晰地使用 APC Plus 余额的方式。AI 助手接入正在设计中。',
    official: '官方网站',
    backTop: '回到顶部 ↑',
    trademark: 'APC Plus 是 APC TECHNOLOGY SDB BHD 的商标。',
    rights: '保留所有权利。',
    footerNav: '页脚导航',
};

const th = {
    metaTitle: 'APC Plus — บัตรกำนัลดิจิทัล บัญชีเดียว',
    metaDescription:
        'ฝากเงิน จัดการเครดิต และเลือกดูบัตรกำนัลดิจิทัลได้ในบัญชี APC Plus เดียว การเข้าถึง AI agent อยู่ในขั้นตอนออกแบบ',
    language: 'ภาษา',
    navHow: 'วิธีการทำงาน',
    navAgents: 'AI Agents',
    signIn: 'เข้าสู่ระบบ',
    brandHome: 'APC Plus กลับขึ้นด้านบน',
    eyebrow: 'พบกับ APC Plus',
    titleLead: 'มูลค่าดิจิทัล ',
    titleAccent: 'พร้อมใช้งาน',
    heroCopy:
        'ฝากเงิน จัดการเครดิต และเลือกดูบัตรกำนัลดิจิทัลได้ในบัญชี APC Plus เดียว เรากำลังออกแบบการเชื่อมต่อผู้ช่วย AI เพื่อช่วยคุณค้นหาสิ่งที่ต้องการ โดยคุณยังเป็นผู้ตัดสินใจ',
    createAccount: 'สร้างบัญชี',
    exploreAgents: 'สำรวจ AI Agents',
    heroNote: 'มีบัญชีอยู่แล้ว?',
    heroNoteLink: 'เข้าสู่ระบบ APC Plus',
    previewLabel: 'ภาพประกอบประสบการณ์ APC Plus',
    previewSub: 'ภาพรวมประสบการณ์',
    yourAccount: 'บัญชีของคุณ',
    credits: 'เครดิตที่ใช้ได้',
    balanceHint: 'ยอดเงินจะแสดงในบัญชีของคุณ',
    giftCards: 'สำรวจบัตรของขวัญ',
    categories: 'หมวดหมู่',
    shopping: 'ช้อปปิ้ง',
    gaming: 'เกม',
    food: 'อาหาร',
    previewFoot: 'การฝากเงินและรายการบัตรกำนัล รวมอยู่ในบัญชีของคุณ',
    illustration: 'ภาพประกอบ',
    howKicker: 'วิธีการทำงาน',
    howTitle: 'ที่เดียวสำหรับเริ่มต้นและสำรวจ',
    howLead: 'APC Plus รวมบัญชี พื้นที่ฝากเงิน และรายการบัตรกำนัลไว้ด้วยกัน',
    step1Title: 'สร้างบัญชี',
    step1Text: 'ลงทะเบียนหรือเข้าสู่ระบบเพื่อเปิดบัญชี APC Plus',
    step2Title: 'ทำตามขั้นตอนการฝาก',
    step2Text: 'เปิดพื้นที่ฝากเงิน และใช้คำแนะนำโทเค็นกับเครือข่ายที่แสดงในบัญชีของคุณ',
    step3Title: 'เลือกดูบัตรกำนัล',
    step3Text: 'สำรวจรายการที่มี และตรวจว่าสินค้าใดเหมาะกับภูมิภาคและความต้องการของคุณ',
    agentsKicker: 'ในแผนงาน · AI Agents',
    agentsTitle: 'ผู้ช่วยช่วยได้ คุณเป็นคนตัดสินใจ',
    agentsLead:
        'ประสบการณ์ APC Plus ถัดไปกำลังถูกออกแบบให้ผู้ช่วย AI ที่เชื่อมต่อแล้วค้นหาบัตรกำนัล ตรวจเครดิต และเตรียมการชำระเงินด้วยบัญชีที่คุณมีอยู่',
    agentPoint1: 'ให้ผู้ช่วยค้นหาบัตรกำนัลที่ใช้ได้และเปรียบเทียบรายละเอียด',
    agentPoint2: 'ตรวจสอบรายการซื้อที่แน่นอนใน APC Plus ก่อนดำเนินการ',
    agentPoint3: 'ควบคุมสิ่งที่เอเจนต์มองเห็น และตัดการเชื่อมต่อเมื่อคุณต้องการ',
    agentsDisclaimer:
        'การเชื่อมต่อ AI agent เป็นตัวอย่างการออกแบบ ยังไม่พร้อมในแอป APC Plus ที่ใช้งานจริง การซื้อเสริมภายในงบที่กำหนดมีแผนในระยะถัดไป',
    demoLabel: 'ภาพประกอบขั้นตอนซื้อกับ AI agent',
    demoTitle: 'ช้อปกับผู้ช่วย',
    demoSub: 'ขั้นตอน APC Plus ที่เสนอ',
    concept: 'แนวคิด',
    youAsk: 'คุณถาม',
    prompt: '“หาบัตรของขวัญที่ฉันใช้ได้ในภูมิภาคของฉัน”',
    flow1: 'ผู้ช่วยค้นหาตัวเลือกที่ใช้ได้',
    flow2: 'APC Plus เตรียมราคาและรายละเอียด',
    flow3: 'คุณอนุมัติการซื้อใน APC Plus',
    demoFoot: 'การอนุมัติจะเกิดขึ้นใน APC Plus ไม่ใช่ในแชทกับผู้ช่วย',
    startKicker: 'เริ่มต้น',
    startTitle: 'บัญชี APC Plus ของคุณเริ่มที่นี่',
    startLead:
        'เข้าสู่ระบบเพื่อใช้การฝากเงินและรายการบัตรกำนัลที่มีอยู่แล้วใน APC Plus หากคุณยังใหม่ ให้สร้างบัญชีก่อน',
    startPoint1: 'ดูคำแนะนำการฝากเงิน',
    startPoint2: 'เลือกดูรายการบัตรกำนัลปัจจุบัน',
    startPoint3: 'การเข้าถึง AI agent กำลังถูกออกแบบสำหรับบัญชีเดียวกันนี้',
    continueTitle: 'ไปต่อที่ APC Plus',
    continueText: 'เลือกเส้นทางที่เหมาะกับคุณ ทั้งสองลิงก์เปิดแอป APC Plus ที่มีอยู่',
    accessNote: 'การเข้าถึง AI agent จะถูกเพิ่มแยกเมื่อเปิดตัว',
    footerBlurb: 'บัตรกำนัลดิจิทัล และวิธีใช้ยอด APC Plus ที่ชัดขึ้น การเข้าถึง AI agent อยู่ในขั้นตอนออกแบบ',
    official: 'เว็บไซต์ทางการ',
    backTop: 'กลับขึ้นด้านบน ↑',
    trademark: 'APC Plus เป็นเครื่องหมายการค้าของ APC TECHNOLOGY SDB BHD',
    rights: 'สงวนลิขสิทธิ์',
    footerNav: 'การนำทางส่วนท้าย',
};

const vi = {
    metaTitle: 'APC Plus — Voucher số, một tài khoản',
    metaDescription:
        'Nạp tiền, quản lý điểm và khám phá voucher số trong một tài khoản APC Plus. Quyền truy cập AI agent đang được thiết kế.',
    language: 'Ngôn ngữ',
    navHow: 'Cách hoạt động',
    navAgents: 'AI Agents',
    signIn: 'Đăng nhập',
    brandHome: 'APC Plus, về đầu trang',
    eyebrow: 'Làm quen với APC Plus',
    titleLead: 'Giá trị số, ',
    titleAccent: 'sẵn sàng dùng.',
    heroCopy:
        'Nạp tiền, quản lý điểm và khám phá voucher số trong một tài khoản APC Plus. Chúng tôi cũng đang thiết kế quyền truy cập AI agent để giúp bạn tìm thứ mình cần, trong khi bạn vẫn nắm quyền quyết định.',
    createAccount: 'Tạo tài khoản',
    exploreAgents: 'Khám phá AI Agents',
    heroNote: 'Đã có tài khoản?',
    heroNoteLink: 'Đăng nhập APC Plus',
    previewLabel: 'Minh họa trải nghiệm APC Plus',
    previewSub: 'Tổng quan trải nghiệm',
    yourAccount: 'Tài khoản của bạn',
    credits: 'Điểm khả dụng',
    balanceHint: 'Số dư hiện trong tài khoản của bạn',
    giftCards: 'Khám phá gift card',
    categories: 'Danh mục',
    shopping: 'Mua sắm',
    gaming: 'Game',
    food: 'Ẩm thực',
    previewFoot: 'Nạp tiền và danh sách voucher, cùng trong tài khoản của bạn.',
    illustration: 'Minh họa',
    howKicker: 'Cách hoạt động',
    howTitle: 'Một nơi để bắt đầu và khám phá.',
    howLead: 'APC Plus gom tài khoản, khu vực nạp tiền và danh sách voucher vào cùng một chỗ.',
    step1Title: 'Tạo tài khoản',
    step1Text: 'Đăng ký hoặc đăng nhập để mở tài khoản APC Plus.',
    step2Title: 'Làm theo bước nạp tiền',
    step2Text: 'Mở khu vực nạp tiền và dùng hướng dẫn token cùng mạng được hiển thị trong tài khoản.',
    step3Title: 'Xem voucher',
    step3Text: 'Khám phá các danh sách hiện có và xem sản phẩm nào phù hợp khu vực cùng nhu cầu của bạn.',
    agentsKicker: 'Lộ trình · AI Agents',
    agentsTitle: 'Trợ lý có thể giúp. Bạn quyết định.',
    agentsLead:
        'Trải nghiệm APC Plus tiếp theo đang được thiết kế để trợ lý AI đã kết nối tìm voucher, kiểm tra điểm và chuẩn bị thanh toán bằng tài khoản hiện có của bạn.',
    agentPoint1: 'Nhờ trợ lý tìm voucher phù hợp và so sánh chi tiết.',
    agentPoint2: 'Xem lại đúng giao dịch trong APC Plus trước khi hoàn tất.',
    agentPoint3: 'Kiểm soát những gì agent được xem, và ngắt kết nối khi bạn muốn.',
    agentsDisclaimer:
        'Kết nối AI agent hiện là bản xem trước thiết kế. Chưa có trên ứng dụng APC Plus đang chạy. Giao dịch tùy chọn trong một ngân sách sẽ được làm ở giai đoạn sau.',
    demoLabel: 'Minh họa luồng mua với AI agent',
    demoTitle: 'Mua cùng trợ lý',
    demoSub: 'Luồng APC Plus đề xuất',
    concept: 'Ý tưởng',
    youAsk: 'Bạn hỏi',
    prompt: '“Tìm gift card tôi dùng được ở khu vực của mình.”',
    flow1: 'Trợ lý tìm các lựa chọn phù hợp',
    flow2: 'APC Plus chuẩn bị giá và chi tiết',
    flow3: 'Bạn duyệt giao dịch trong APC Plus',
    demoFoot: 'Việc duyệt diễn ra trong APC Plus, không phải trong cuộc trò chuyện với trợ lý.',
    startKicker: 'Bắt đầu',
    startTitle: 'Tài khoản APC Plus của bạn bắt đầu từ đây.',
    startLead:
        'Đăng nhập để dùng tính năng nạp tiền và danh sách voucher đã có trên APC Plus. Nếu bạn mới, hãy tạo tài khoản trước.',
    startPoint1: 'Xem hướng dẫn nạp tiền.',
    startPoint2: 'Duyệt danh sách voucher hiện tại.',
    startPoint3: 'Quyền truy cập AI agent đang được thiết kế cho chính tài khoản này.',
    continueTitle: 'Tiếp tục tới APC Plus',
    continueText: 'Chọn cách phù hợp với bạn. Cả hai liên kết đều mở ứng dụng APC Plus hiện có.',
    accessNote: 'Quyền truy cập AI agent sẽ được thêm riêng khi ra mắt.',
    footerBlurb:
        'Voucher số và cách dùng số dư APC Plus rõ hơn. Quyền truy cập AI agent đang trong giai đoạn thiết kế.',
    official: 'Website chính thức',
    backTop: 'Lên đầu trang ↑',
    trademark: 'APC Plus là thương hiệu của APC TECHNOLOGY SDB BHD.',
    rights: 'Mọi quyền được bảo lưu.',
    footerNav: 'Điều hướng chân trang',
};

const ja = {
    metaTitle: 'APC Plus — デジタルギフト、ひとつのアカウント',
    metaDescription:
        '入金、クレジット管理、デジタルギフトの閲覧を、ひとつの APC Plus アカウントで。AI エージェント接続は設計中です。',
    language: '言語',
    navHow: '使い方',
    navAgents: 'AIエージェント',
    signIn: 'サインイン',
    brandHome: 'APC Plus、ページ上部へ',
    eyebrow: 'APC Plus へようこそ',
    titleLead: 'デジタルの価値を、',
    titleAccent: 'すぐ使える。',
    heroCopy:
        '入金、クレジット管理、デジタルギフトの閲覧を、ひとつの APC Plus アカウントで。必要なものを見つける AI エージェント接続も設計中です。決めるのはあなたです。',
    createAccount: 'アカウントを作成',
    exploreAgents: 'AIエージェントを見る',
    heroNote: 'すでにアカウントをお持ちですか？',
    heroNoteLink: 'APC Plus にサインイン',
    previewLabel: 'APC Plus 体験のイラスト',
    previewSub: '体験の概要',
    yourAccount: 'あなたのアカウント',
    credits: '利用可能クレジット',
    balanceHint: '残高はアカウントに表示されます',
    giftCards: 'ギフトカードを見る',
    categories: 'カテゴリ',
    shopping: 'ショッピング',
    gaming: 'ゲーム',
    food: 'フード',
    previewFoot: '入金とバウチャー一覧が、アカウントにまとまります。',
    illustration: 'イラスト',
    howKicker: '使い方',
    howTitle: '始めて、探す場所はひとつ。',
    howLead: 'APC Plus はアカウント、入金エリア、バウチャー一覧をひとつにまとめます。',
    step1Title: 'アカウントを作成',
    step1Text: '登録またはサインインして、APC Plus アカウントを開きます。',
    step2Title: '入金手順に従う',
    step2Text: '入金エリアを開き、アカウントに表示されるトークンとネットワークの案内を使います。',
    step3Title: 'バウチャーを見る',
    step3Text: '公開中の一覧を見て、地域と用途に合う商品を確認します。',
    agentsKicker: 'ロードマップ · AIエージェント',
    agentsTitle: '助手は手伝えます。決めるのはあなた。',
    agentsLead:
        '次の APC Plus では、接続した AI アシスタントがバウチャーを探し、クレジットを確認し、今のアカウントで購入手続きを準備できるように設計しています。',
    agentPoint1: '条件に合うバウチャーを探し、内容を比べるよう助手に頼めます。',
    agentPoint2: '実行前に、APC Plus で購入内容をそのまま確認できます。',
    agentPoint3: 'エージェントが見られる情報を管理し、いつでも切断できます。',
    agentsDisclaimer:
        'AI エージェント接続はデザイン上のプレビューです。公開中の APC Plus アプリではまだ使えません。予算内の任意購入は後の段階で予定しています。',
    demoLabel: 'AI エージェント購入の流れの例',
    demoTitle: '助手と一緒に買う',
    demoSub: '提案中の APC Plus の流れ',
    concept: 'コンセプト',
    youAsk: 'あなたが頼む',
    prompt: '「自分の地域で使えるギフトカードを探して。」',
    flow1: '助手が使える選択肢を見つける',
    flow2: 'APC Plus が価格と詳細を準備する',
    flow3: 'あなたが APC Plus で購入を承認する',
    demoFoot: '承認は助手とのチャットではなく、APC Plus の中で行います。',
    startKicker: 'はじめる',
    startTitle: 'APC Plus アカウントはここから。',
    startLead:
        'サインインすると、すでに使える入金とバウチャー一覧を利用できます。初めての方は、先にアカウントを作成してください。',
    startPoint1: '入金の案内を確認する。',
    startPoint2: '現在のバウチャー一覧を見る。',
    startPoint3: 'AI エージェント接続は、この同じアカウント向けに設計中です。',
    continueTitle: 'APC Plus に進む',
    continueText: '自分に合う方を選んでください。どちらのリンクも既存の APC Plus アプリを開きます。',
    accessNote: 'AI エージェント接続は、公開時に別途追加されます。',
    footerBlurb: 'デジタルバウチャーと、APC Plus 残高のわかりやすい使い方。AI エージェント接続は設計中です。',
    official: '公式サイト',
    backTop: 'ページ上部へ ↑',
    trademark: 'APC Plus は APC TECHNOLOGY SDB BHD の商標です。',
    rights: '全著作権所有。',
    footerNav: 'フッターナビゲーション',
};

const ko = {
    metaTitle: 'APC Plus — 디지털 바우처, 하나의 계정',
    metaDescription:
        '입금, 크레딧 관리, 디지털 바우처 탐색을 하나의 APC Plus 계정에서. AI 에이전트 접속은 설계 중입니다.',
    language: '언어',
    navHow: '이용 방법',
    navAgents: 'AI 에이전트',
    signIn: '로그인',
    brandHome: 'APC Plus, 맨 위로',
    eyebrow: 'APC Plus를 만나보세요',
    titleLead: '디지털 가치, ',
    titleAccent: '바로 사용하세요.',
    heroCopy:
        '입금, 크레딧 관리, 디지털 바우처 탐색을 하나의 APC Plus 계정에서 할 수 있습니다. 필요한 것을 찾도록 돕는 AI 에이전트 접속도 설계 중이며, 결정은 여러분이 합니다.',
    createAccount: '계정 만들기',
    exploreAgents: 'AI 에이전트 살펴보기',
    heroNote: '이미 계정이 있나요?',
    heroNoteLink: 'APC Plus 로그인',
    previewLabel: 'APC Plus 경험 일러스트',
    previewSub: '경험 개요',
    yourAccount: '내 계정',
    credits: '사용 가능 크레딧',
    balanceHint: '잔액은 계정에 표시됩니다',
    giftCards: '기프트 카드 둘러보기',
    categories: '카테고리',
    shopping: '쇼핑',
    gaming: '게임',
    food: '푸드',
    previewFoot: '입금과 바우처 목록이 계정 안에 함께 있습니다.',
    illustration: '일러스트',
    howKicker: '이용 방법',
    howTitle: '시작하고 둘러보는 곳, 하나면 됩니다.',
    howLead: 'APC Plus는 계정, 입금 영역, 바우처 목록을 한곳에 모읍니다.',
    step1Title: '계정 만들기',
    step1Text: '가입하거나 로그인하여 APC Plus 계정을 엽니다.',
    step2Title: '입금 단계 따르기',
    step2Text: '입금 영역을 열고, 계정에 표시된 토큰과 네트워크 안내를 따릅니다.',
    step3Title: '바우처 둘러보기',
    step3Text: '현재 목록을 살펴보고 지역과 필요에 맞는 상품을 확인합니다.',
    agentsKicker: '로드맵 · AI 에이전트',
    agentsTitle: '도우미가 도울 수 있습니다. 결정은 여러분이 합니다.',
    agentsLead:
        '다음 APC Plus 경험은 연결된 AI 도우미가 바우처를 찾고, 크레딧을 확인하며, 기존 계정으로 결제를 준비하도록 설계되고 있습니다.',
    agentPoint1: '도우미에게 사용 가능한 바우처를 찾고 내용을 비교해 달라고 할 수 있습니다.',
    agentPoint2: '진행되기 전에 APC Plus에서 정확한 구매 내용을 확인합니다.',
    agentPoint3: '에이전트가 볼 수 있는 정보를 정하고, 원할 때 연결을 끊을 수 있습니다.',
    agentsDisclaimer:
        'AI 에이전트 연결은 디자인 미리보기입니다. 현재 운영 중인 APC Plus 앱에서는 아직 사용할 수 없습니다. 예산 안의 선택 구매는 이후 단계에서 계획되어 있습니다.',
    demoLabel: 'AI 에이전트 구매 흐름 예시',
    demoTitle: '도우미와 함께 쇼핑',
    demoSub: '제안된 APC Plus 흐름',
    concept: '콘셉트',
    youAsk: '이렇게 요청합니다',
    prompt: '“내 지역에서 쓸 수 있는 기프트 카드를 찾아 줘.”',
    flow1: '도우미가 가능한 옵션을 찾습니다',
    flow2: 'APC Plus가 가격과 상세 내용을 준비합니다',
    flow3: 'APC Plus에서 구매를 승인합니다',
    demoFoot: '승인은 도우미 대화가 아니라 APC Plus 안에서 이루어집니다.',
    startKicker: '시작하기',
    startTitle: 'APC Plus 계정은 여기서 시작합니다.',
    startLead:
        '로그인하면 APC Plus에서 이미 제공되는 입금과 바우처 목록을 사용할 수 있습니다. 처음이라면 먼저 계정을 만드세요.',
    startPoint1: '입금 안내를 확인합니다.',
    startPoint2: '현재 바우처 목록을 둘러봅니다.',
    startPoint3: 'AI 에이전트 접속은 이 같은 계정을 위해 설계 중입니다.',
    continueTitle: 'APC Plus로 계속',
    continueText: '자신에게 맞는 경로를 고르세요. 두 링크 모두 기존 APC Plus 앱을 엽니다.',
    accessNote: 'AI 에이전트 접속은 출시될 때 따로 추가됩니다.',
    footerBlurb: '디지털 바우처와 APC Plus 잔액을 더 분명하게 쓰는 방법. AI 에이전트 접속은 설계 중입니다.',
    official: '공식 웹사이트',
    backTop: '맨 위로 ↑',
    trademark: 'APC Plus는 APC TECHNOLOGY SDB BHD의 상표입니다.',
    rights: '모든 권리 보유.',
    footerNav: '푸터 탐색',
};

const id = {
    metaTitle: 'APC Plus — Voucher digital, satu akun',
    metaDescription:
        'Setor, kelola kredit, dan jelajahi voucher digital dalam satu akun APC Plus. Akses agen AI sedang dirancang.',
    language: 'Bahasa',
    navHow: 'Cara kerja',
    navAgents: 'AI Agents',
    signIn: 'Masuk',
    brandHome: 'APC Plus, kembali ke atas',
    eyebrow: 'Kenalan dengan APC Plus',
    titleLead: 'Nilai digital, ',
    titleAccent: 'siap dipakai.',
    heroCopy:
        'Setor, kelola kredit, dan jelajahi voucher digital dalam satu akun APC Plus. Kami juga merancang akses agen AI untuk membantu Anda menemukan yang dibutuhkan, sementara Anda tetap yang memutuskan.',
    createAccount: 'Buat akun',
    exploreAgents: 'Jelajahi AI Agents',
    heroNote: 'Sudah punya akun?',
    heroNoteLink: 'Masuk ke APC Plus',
    previewLabel: 'Ilustrasi pengalaman APC Plus',
    previewSub: 'Ringkasan pengalaman',
    yourAccount: 'Akun Anda',
    credits: 'Kredit tersedia',
    balanceHint: 'Saldo muncul di akun Anda',
    giftCards: 'Jelajahi gift card',
    categories: 'Kategori',
    shopping: 'Belanja',
    gaming: 'Game',
    food: 'Makanan',
    previewFoot: 'Setoran dan daftar voucher, bersama di akun Anda.',
    illustration: 'Ilustrasi',
    howKicker: 'Cara kerja',
    howTitle: 'Satu tempat untuk mulai dan menjelajah.',
    howLead: 'APC Plus menyatukan akun, area setoran, dan daftar voucher.',
    step1Title: 'Buat akun',
    step1Text: 'Daftar atau masuk untuk membuka akun APC Plus.',
    step2Title: 'Ikuti langkah setoran',
    step2Text: 'Buka area setoran dan gunakan petunjuk token serta jaringan yang tampil di akun Anda.',
    step3Title: 'Lihat voucher',
    step3Text: 'Jelajahi daftar yang tersedia dan cek produk yang sesuai wilayah serta kebutuhan Anda.',
    agentsKicker: 'Dalam peta jalan · AI Agents',
    agentsTitle: 'Asisten bisa membantu. Anda yang memutuskan.',
    agentsLead:
        'Pengalaman APC Plus berikutnya dirancang agar asisten AI yang terhubung mencari voucher, memeriksa kredit, dan menyiapkan checkout dengan akun yang sudah Anda punya.',
    agentPoint1: 'Minta asisten mencari voucher yang sesuai dan membandingkan detailnya.',
    agentPoint2: 'Tinjau pembelian yang tepat di APC Plus sebelum diproses.',
    agentPoint3: 'Atur apa yang boleh dilihat agen, dan putuskan koneksinya kapan pun Anda mau.',
    agentsDisclaimer:
        'Koneksi agen AI masih pratinjau desain. Belum tersedia di aplikasi APC Plus yang aktif. Pembelian opsional dalam anggaran tertentu direncanakan pada tahap berikutnya.',
    demoLabel: 'Ilustrasi alur pembelian dengan agen AI',
    demoTitle: 'Belanja bersama asisten',
    demoSub: 'Alur APC Plus yang diusulkan',
    concept: 'Konsep',
    youAsk: 'Anda bertanya',
    prompt: '“Cari gift card yang bisa saya pakai di wilayah saya.”',
    flow1: 'Asisten menemukan opsi yang sesuai',
    flow2: 'APC Plus menyiapkan harga dan detail',
    flow3: 'Anda menyetujui pembelian di APC Plus',
    demoFoot: 'Persetujuan terjadi di APC Plus, bukan di obrolan asisten.',
    startKicker: 'Mulai',
    startTitle: 'Akun APC Plus Anda dimulai di sini.',
    startLead:
        'Masuk untuk memakai setoran dan daftar voucher yang sudah tersedia di APC Plus. Jika baru, buat akun terlebih dahulu.',
    startPoint1: 'Lihat petunjuk setoran Anda.',
    startPoint2: 'Jelajahi daftar voucher saat ini.',
    startPoint3: 'Akses agen AI sedang dirancang untuk akun yang sama.',
    continueTitle: 'Lanjut ke APC Plus',
    continueText: 'Pilih jalur yang sesuai. Kedua tautan membuka aplikasi APC Plus yang sudah ada.',
    accessNote: 'Akses agen AI akan ditambahkan terpisah saat diluncurkan.',
    footerBlurb:
        'Voucher digital dan cara yang lebih jelas untuk memakai saldo APC Plus. Akses agen AI masih dalam desain.',
    official: 'Situs resmi',
    backTop: 'Kembali ke atas ↑',
    trademark: 'APC Plus adalah merek dagang dari APC TECHNOLOGY SDB BHD.',
    rights: 'Hak cipta dilindungi.',
    footerNav: 'Navigasi footer',
};

function withRefresh(base, lang) {
    const landing = page[lang] || page.en;
    return { ...base, ...refresh[lang], ...landing };
}

export const translations = {
    en: withRefresh(en, 'en'),
    zh: withRefresh(zh, 'zh'),
    th: withRefresh(th, 'th'),
    vi: withRefresh(vi, 'vi'),
    ja: withRefresh(ja, 'ja'),
    ko: withRefresh(ko, 'ko'),
    id: withRefresh(id, 'id'),
};
